import { Typography } from 'antd'
import styled from 'styled-components'

const StyledLogo = styled(Typography.Text)`
  font-style: italic;
`
export default StyledLogo
